'use strict';
module.exports = require('../../full/array/from');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/features/array/from.js
// module id = 1233
// module chunks = 0